import { render, staticRenderFns } from "./CancelOnboardingButton.vue?vue&type=template&id=5255f8a6&scoped=true&"
import script from "./CancelOnboardingButton.vue?vue&type=script&lang=js&"
export * from "./CancelOnboardingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5255f8a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
